import React from "react";
import FormTemplates from "modules/formTemplates";

const FormTemplatesPage = () => {
  return <FormTemplates />;
};

export default FormTemplatesPage;
